/**
 * Company: SPHMedia
 * Description: [MosqueButton component for displaying prayer time]
 */

import moreCollapsedImg from "@assets/header/newIcons/more-collapsed.svg";
import moreExpandedImg from "@assets/header/newIcons/more-expanded.svg";
import MosqueLogo from "@assets/prayer-time/Mosque-new.svg";
import { ButtonHTMLAttributes, ReactElement } from "react";
import { twMerge } from "tailwind-merge";

type MosqueButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick?: () => void;
  variant?: "iconOnly" | "withText";
  wrapperClass?: string;
  clicked?: boolean;
};

/**
 * MosqueButton
 * Description: [Toggle button for displaying prayer time]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function MosqueButton(props: MosqueButtonProps): ReactElement {
  // Add component logic and state here
  const {
    onClick,
    variant = "iconOnly",
    wrapperClass,
    clicked = false,
  } = props;

  const isWithText = variant === "withText";
  const mosqueHeight = isWithText ? 11 : 17;
  const mosqueWidth = isWithText ? 13 : 20;
  const MoreExpandedIcon = moreExpandedImg;
  const MoreCollapsedIcon = moreCollapsedImg;

  return (
    <>
      <button
        data-testid="mosque-btn"
        className={twMerge("p-2.5", wrapperClass)}
        onClick={onClick}
        {...props}
      >
        <img
          src={MosqueLogo}
          alt="Mosque Logo"
          height={mosqueHeight}
          width={mosqueWidth}
        />
        {variant === "withText" && (
          <span className="text-xs text-brand-primary font-regular flex gap-1 items-center">
            Prayer Time
            <img
              src={clicked ? MoreExpandedIcon : MoreCollapsedIcon}
              alt="more-menu-icon"
              width={12}
              height={12}
            />
          </span>
        )}
      </button>
    </>
  );
}
